import { createAuth } from '@thehotelsnetwork/vue-auth';
import { createHttpClient } from '@thehotelsnetwork/http-client';

import browserStorage from '../BrowserStorage';

import { apiURL } from '@/config';

function getBaseUrl() {
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.host}`;
}

const auth = createAuth({
  settings: {
    loginUrl: `${getBaseUrl()}/login`,
  },
  storage: browserStorage,
  httpClient: createHttpClient({
    baseURL: apiURL.base,
  }),
});

export default auth;
